import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import React from 'react';

import ButtonGoUp from '@components/common/ButtonGoUp/ButtonGoUp';
import Button from '@components/uikit/Button/Button';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import type { ITableSorting } from '@model/tableSorting';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import { useExportEngagementReportMutation } from '../../services/useExportEngagementReportMutation';
import {
  selectEngagementFilterCartRangeValue,
  selectEngagementFilterSearchValue,
  selectEngagementFilterState,
} from '../../store/useEngagementFilterStore';
import style from './style.module.scss';

interface IProps {
  items: number;
  total: number;
  sorting: ITableSorting;
  engagementActionItemsTableContainerRef: React.LegacyRef<HTMLDivElement>;
}

const Footer: React.FC<IProps> = ({ items, total, sorting, engagementActionItemsTableContainerRef }) => {
  const { t } = useTranslation();
  const { mutate: exportEngagementReportMutate } = useExportEngagementReportMutation();

  const { data: profileData } = useUserProfileQuery();

  const locationSelectValue = selectAppLocationSelectValue();
  const searchValue = selectEngagementFilterSearchValue();
  const filter = selectEngagementFilterState();
  const cartRange = selectEngagementFilterCartRangeValue();

  const downloadReport = () => {
    showToast({ variant: 'success', message: t('The download will begin shortly.') });

    exportEngagementReportMutate(
      {
        filter,
        cartRange,
        search: searchValue,
        locationIds:
          locationSelectValue.level_name === 'allFacilities' ? undefined : locationSelectValue.filterIds,
        sorting,
      },
      {
        onSuccess: (data) => {
          saveAs(
            new Blob([data?.data], { type: 'text/plain;charset=utf-8' }),
            `${profileData?.customer?.name} Engagement Report ${format(new Date(), 'P p')}.csv`,
          );
        },
      },
    );
  };

  return (
    <div className={style.siteEngagementFooterWrapper}>
      <span className={style.total}>
        {`${t('Displaying')} ${items} ${t('of')} ${total} ${t('Action Items')}`}.
      </span>
      <div className={style.buttonsWrapper}>
        <Button type="primary" variant="medium" text={t('Download report')} onClick={downloadReport} />
        <ButtonGoUp ref={engagementActionItemsTableContainerRef} />
      </div>
    </div>
  );
};

export default Footer;
